<script>
    import { Line, mixins } from 'vue-chartjs';

    const { reactiveProp } = mixins;

    export default {
        extends: Line,
        mixins: [reactiveProp],
        props: ['height', 'miny', 'maxy', 'changeyaxis'],
        data () {
            return {
                // Chart.js options that control the appearance of the chart
                options: {
                    tooltips: {
                        intersect: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'right',
                        labels: {
                            boxWidth: 20,
                        },
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                min: this.miny,
                                max: this.maxy,
                                maxTicksLimit: 5,
                            },
                            gridLines: {
                                display: true,
                            },
                        }],
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false,
                            },
                        }],
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3,
                        },
                    },
                },
            };
        },
        mounted () {
            //adding the plugin to draw the red dot
            this.addPlugin({
                id: 'chart-plugin',
                afterDatasetsDraw: function (chart) {
                    // indexen waar de verticale lijnen moeten komen
                    var lines = chart.data.verticallines;
                    // welke waarden bij de verticale lijnen getoond moeten worden
                    var values = chart.data.values;

                    var c = chart.canvas;
                    var ctx = c.getContext("2d");

                    var xaxis = chart.scales['x-axis-0'];
                    var yaxis = chart.scales['y-axis-0'];

                    for (var i = 0; i < lines.length; i++) {
                        var index = lines[i];

                        ctx.lineWidth = 1;
                        ctx.strokeStyle = '#0bb6ff';

                        ctx.beginPath();
                        ctx.moveTo(xaxis.getPixelForValue(undefined, index), 0);
                        ctx.lineTo(xaxis.getPixelForValue(undefined, index), yaxis.bottom + 5);
                        ctx.stroke();

                        ctx.beginPath();
                        ctx.font = "10px Verdana";
                        ctx.fillStyle = '#0bb6ff';
                        ctx.fillText(values[i], xaxis.getPixelForValue(undefined, index) + 5, yaxis.bottom - 7);
                    }
                }
            });
            // this.chartData is created in the mixin and
            // contains all the data needed to build the chart
            this.renderChart(this.chartData, this.options);
        },
        watch: {
            changeyaxis () {
                /* eslint no-underscore-dangle: ["error", { "allow": ["_chart"] }] */
                this.$data._chart.destroy();
                this.options.scales.yAxes[0].ticks.min = this.miny;
                //this.options.scales.yAxes[1].ticks.min = this.miny;
                this.options.scales.yAxes[0].ticks.max = this.maxy;
                //this.options.scales.yAxes[1].ticks.max = this.maxy;
                this.renderChart(this.chartData, this.options);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/licht/ChartLineVerticalLine.vue